import { CommonModule, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MijnActieTemplateModule } from '../mijn-actie-template/mijn-actie-template.module';
import { MijnOverzichtTemplateModule } from '../mijn-overzicht-template/mijn-overzicht-template.module';

import { MijnOmgevingTemplateComponent } from './mijn-omgeving-template.component';

@NgModule({
    imports: [MijnActieTemplateModule, MijnOverzichtTemplateModule, CommonModule, RouterModule, NgClass],
    exports: [MijnOmgevingTemplateComponent],
    declarations: [MijnOmgevingTemplateComponent]
})
export class MijnOmgevingTemplateModule {}
